module.exports = __webpack_public_path__ + "static/media/spacebreak.c3921594.gif";